module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j1NQx"))).then(() => parcelRequire('d0iPb'));